export const VERSION = '02/07/2025 [14:40]';